// extracted by mini-css-extract-plugin
module.exports = {"ListWithDescription":"List_ListWithDescription__2i7wR","ListWithDescription__item":"List_ListWithDescription__item__5JneY"};